/* eslint-disable react/require-default-props */
import React, { useRef, useCallback } from 'react';
import { IoIosArrowDown, IoIosClose } from 'react-icons/io';

import grid from '~/styles/grid';

import { Container, Content, ChipContainer, Chip } from './styles';

interface BaseType {
  id: string;
  label: string;
  value: string;
}

interface Props<Type> {
  name: string;
  label?: string | null;
  optional?: boolean;
  disabled?: boolean;
  isRequired?: boolean;
  onClickSearch: () => void;
  value?: Type[];
  onUpdateValues: (newValues?: Type[]) => void;
  error?: string;
}
type InputProps<Type> = Omit<JSX.IntrinsicElements['input'], 'value'> &
  Props<Type>;

function InputSearch<Type extends BaseType>({
  name,
  label = null,
  optional = false,
  disabled = false,
  isRequired = false,
  value,
  onClickSearch,
  onUpdateValues,
  error,
  ...rest
}: InputProps<Type>): JSX.Element {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleDeleteOption = useCallback(
    (option) => {
      if (!value) {
        return;
      }

      const filteredValues = value.filter(({ id }) => id !== option);
      const newValues = filteredValues.length > 0 ? filteredValues : undefined;

      onUpdateValues(newValues);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value],
  );

  const handleClickSearch = () => {
    if (disabled) {
      return;
    }
    onClickSearch();
  };

  return (
    <Container isRequired={isRequired} disabled={disabled}>
      {(label || optional) && (
        <div>
          {label && <label htmlFor={name}>{label}</label>}
          {optional && <small>(opcional)</small>}
        </div>
      )}
      <Content role="button" disabled={disabled} onClick={handleClickSearch}>
        <input id={name} ref={inputRef} disabled={disabled} {...rest} />
        <ChipContainer>
          {Array.isArray(value) &&
            value.map((option) => {
              if (option) {
                return (
                  <Chip
                    key={option.id}
                    label={option.label}
                    deleteIcon={<IoIosClose />}
                    onDelete={() => handleDeleteOption(option.id)}
                  />
                );
              }

              return null;
            })}
        </ChipContainer>
        <button type="button" disabled={disabled} onClick={handleClickSearch}>
          <IoIosArrowDown style={{ width: grid.md, height: 'auto' }} />
        </button>
      </Content>
      {error && <span>{error}</span>}
    </Container>
  );
}
export default InputSearch;
